import script from "./LeaveAdminRequestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveAdminRequestsView.vue?vue&type=script&setup=true&lang=js"

import "./LeaveAdminRequestsView.vue?vue&type=style&index=0&id=aa9f27e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa9f27e4"]])

export default __exports__